export const isStringHtml = (string: string) => {
  const regexForHTML = /<([A-Za-z][A-Za-z0-9]*)\b[^>]*>(.*?)<\/\1>/;
  const isValid = regexForHTML.test(string);
  if (isValid) {
    return true;
  }
  return false;
};
